// src/components/Auth/AuthContext.js
import React, { createContext, useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const history = useHistory();
  useEffect(() => {
    function getToken() {
      return localStorage.getItem('authToken');
    }
    const token = getToken();
    const role = localStorage.getItem('role');
    if (token && role) {
      // Simulasi verifikasi token atau fetch data pengguna
      setCurrentUser({ token, role });
    }
  }, []);

  function login(token, role) {
    setCurrentUser({ token, role });
    localStorage.setItem('authToken', token);
    localStorage.setItem('role', role);
  }

  function logout() {
    setCurrentUser(null);
    localStorage.removeItem('authToken');
    localStorage.removeItem('role');
    localStorage.removeItem('role');
    localStorage.removeItem('tentorId');
    localStorage.removeItem('userId');
    history.push('/landing');
  }

  const value = {
    currentUser,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
